/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 14:07:10
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-07 14:42:05
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/discounts/index.ts
 */
import { post, get } from 'src/tools/server';

export const validPromoCode = (data) => {
  return post<any>(`/portal/discount/validCode`, data || {}, {});
};

export const getDiscountDetail = (salesChannelUuid, discountUuid, params) => {
  return get<any>(`/portal/${salesChannelUuid}/discountPage`, {
    ...params,
    params: { discountUuid },
  });
};

export const draftDiscount = (discountUuid) => {
  return post<any>(`/portal/discount/draft/${discountUuid}`, {}, {});
};
export const activateDiscount = (discountUuid) => {
  return post<any>(`/portal/discount/activate/${discountUuid}`, {}, {});
};
export const archiveDiscount = (discountUuid) => {
  return post<any>(`/portal/discount/archive/${discountUuid}`, {}, {});
};

export const bulkDraftDiscount = (discountUuids) => {
  return post<any>(`/portal/discounts/draft`, { discountUuids }, {});
};
export const bulkActivateDiscount = (discountUuids) => {
  return post<any>(`/portal/discounts/activate`, { discountUuids }, {});
};
export const bulkArchiveDiscount = (discountUuids) => {
  return post<any>(`/portal/discounts/archive`, { discountUuids }, {});
};

export const bulkCloneDiscount = (discountUuids) => {
  return post<any>(`/portal/discounts/clone`, { discountUuids }, {});
};
